import {
  LockFreeLinkedListNode18403qmazubk5 as LockFreeLinkedListNode,
  LockFreeLinkedListHeaduwhs9comnpmn as LockFreeLinkedListHead,
} from './internal/LinkedList.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import {
  get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName,
  get_hexAddress1mxa7txdmiojm as get_hexAddress,
  get_DEBUG1a8uv2i5oid01 as get_DEBUG,
} from './Debug.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  NonDisposableHandle_instance2ndlgmw6n2fs7 as NonDisposableHandle_instance,
  invokeOnCompletion3npqdfp2wzhn6 as invokeOnCompletion,
  ParentJob1a3idoswyjefg as ParentJob,
  Key_instancebefxze3q9f64 as Key_instance,
  invokeOnCompletion$default3ce018mbgf2ad as invokeOnCompletion$default,
  ensureActive2yo7199srjlgl as ensureActive,
  cancel$default2xpiixsrbjcxw as cancel$default,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally } from './CompletionState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from './Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException } from './Timeout.mjs';
import { identitySet1lu9dl60optk8 as identitySet } from './internal/Concurrent.mjs';
import { unwrap34f7x4f5snsxt as unwrap } from './internal/StackTraceRecovery.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { CompletionHandlerException1h8udyjlr1wky as CompletionHandlerException } from './Exceptions.common.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  anyToString3ho3k49fc56mj as anyToString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './CancellableContinuationImpl.mjs';
import { disposeOnCancellation302lv5bib5mna as disposeOnCancellation } from './CancellableContinuation.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { SynchronizedObject32xqzf15iiskd as SynchronizedObject } from './internal/Synchronized.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from '../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  plusolev77jfy5r9 as plus,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
} from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from './CompletableJob.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './internal/Symbol.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
var JobNodeClass;
function JobNode() {
  if (JobNodeClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      i12() {
        var tmp = this.h12_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('job');
        }
      }
      dw() {
        return true;
      }
      j12() {
        return null;
      }
      tz() {
        return this.i12().kx(this);
      }
      toString() {
        return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.i12()) + ']';
      }
    }
    initMetadataForClass($, 'JobNode', VOID, VOID, [DisposableHandle(), Incomplete()]);
    JobNodeClass = $;
  }
  return JobNodeClass;
}
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox() ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o14_1;
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function _set_exceptionsHolder__tqm22h($this, value) {
  $this.s14_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this.s14_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList().i2(4);
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally() ? proposedUpdate : null;
  var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iw_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  wasCancelling = state.t14();
  var exceptions = state.u14(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new (CompletedExceptionally())(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.zx(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally() ? finalState : THROW_CCE()).x10();
    }
  }
  if (!wasCancelling) {
    $this.wx(finalException);
  }
  $this.hw(finalState);
  var casSuccess = $this.wv_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.n1()) {
    if (state.t14()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return JobCancellationException().b15(null == null ? $this.gw() : null, null, $this);
    }
    return null;
  }
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = exceptions.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element instanceof CancellationException())) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var firstNonCancellation = tmp$ret$1;
  if (!(firstNonCancellation == null))
    return firstNonCancellation;
  var first = exceptions.r2(0);
  if (first instanceof TimeoutCancellationException()) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = exceptions.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$3 = null;
    }
    var detailedTimeoutException = tmp$ret$3;
    if (!(detailedTimeoutException == null))
      return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.q2() <= 1)
    return Unit_instance;
  var seenExceptions = identitySet(exceptions.q2());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.p1();
  while (_iterator__ex2g4s.q1()) {
    var exception = _iterator__ex2g4s.r1();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.j2(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this.wv_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
    return false;
  $this.wx(null);
  $this.hw(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp0_safe_receiver = $this.vw();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.tz();
    $this.uw(NonDisposableHandle_instance);
  }
  var tmp1_safe_receiver = update instanceof CompletedExceptionally() ? update : null;
  var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.iw_1;
  if (state instanceof JobNode()) {
    try {
      state.sz(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.ow(CompletionHandlerException().o10('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp2_safe_receiver = state.j12();
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCompletion($this, tmp2_safe_receiver, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.wx(cause);
  list.c15(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list.k12_1;
  while (!equals(cur, list)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode()) {
      tmp = node.d12();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.sz(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = CompletionHandlerException().o10('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.k12_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.ow(tmp0_safe_receiver_0);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.xx())
    return true;
  var isCancellation = cause instanceof CancellationException();
  var parent = $this.vw();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.qx(cause) || isCancellation;
}
function notifyCompletion($this, $receiver, cause) {
  $receiver.c15(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = $receiver.k12_1;
  while (!equals(cur, $receiver)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode()) {
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.sz(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = CompletionHandlerException().o10('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.k12_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.ow(tmp0_safe_receiver_0);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty()) {
    if (state.e15_1)
      return 0;
    if (!$this.wv_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
      return -1;
    $this.bx();
    return 1;
  } else {
    if (state instanceof InactiveNodeList()) {
      if (!$this.wv_1.atomicfu$compareAndSet(state, state.d15_1))
        return -1;
      $this.bx();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new (NodeList())();
  var update = state.e15_1 ? list : new (InactiveNodeList())(list);
  $this.wv_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.p12(new (NodeList())());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state.k12_1;
  $this.wv_1.atomicfu$compareAndSet(state, list);
}
function joinInternal($this) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.xw();
    if (!(!(state == null) ? isInterface(state, Incomplete()) : false))
      return false;
    if (startInternal($this, state) >= 0)
      return true;
  }
}
function *joinSuspend($this, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.a11();
    disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new (ResumeOnCompletion())(cancellable)));
    return cancellable.ky();
  });
  return Unit_instance;
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.xw();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing()) {
        tmp_0 = state.f15();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new (CompletedExceptionally())(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY()))
      return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = JobCancellationException().b15(null == null ? $this.gw() : null, null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = (isInterface(cause, ParentJob()) ? cause : THROW_CCE()).tx();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp0 = $this.xw();
    $l$block: {
      if (tmp0 instanceof Finishing()) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        if (tmp0.g15())
          return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = tmp0.t14();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          tmp0.h15(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = tmp0.i15();
        var tmp_0;
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          notifyCancelling($this, tmp0.p14_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(tmp0 == null) ? isInterface(tmp0, Incomplete()) : false) {
          var tmp2_elvis_lhs = causeExceptionCache;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var causeException_0 = tmp_1;
          if (tmp0.dw()) {
            if (tryMakeCancelling($this, tmp0, causeException_0))
              return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, tmp0, new (CompletedExceptionally())(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString(tmp0);
              throw IllegalStateException().o(toString(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.j12();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty()) {
      tmp_0 = new (NodeList())();
    } else {
      if (state instanceof JobNode()) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'State should have list: ' + toString(state);
        throw IllegalStateException().o(toString(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new (Finishing())(list, false, rootCause);
  if (!$this.wv_1.atomicfu$compareAndSet(state, cancelling))
    return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete()) : false))
    return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty()) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode();
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally());
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing() ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new (Finishing())(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.f15())
    return get_COMPLETING_ALREADY();
  finishing.j15(true);
  if (!(finishing === state)) {
    if (!$this.wv_1.atomicfu$compareAndSet(state, finishing))
      return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.t14();
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally() ? proposedUpdate : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    finishing.h15(tmp0_safe_receiver.iw_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.i15();
  var tmp_0;
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild($this, list);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  list.c15(2);
  var anotherChild = nextChild($this, list);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js($this, $receiver) {
  var tmp0_safe_receiver = $receiver instanceof CompletedExceptionally() ? $receiver : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iw_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  $l$1: do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.o15_1, false, new (ChildCompletion())($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance))
        return true;
      var tmp0_elvis_lhs = nextChild($this_0, child_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_0;
      var tmp1 = state_0;
      var tmp3 = proposedUpdate_0;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = nextChild_0;
      proposedUpdate_0 = tmp3;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild($this, lastChild);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
    return Unit_instance;
  state.p14_1.c15(2);
  var waitChildAgain = nextChild($this, lastChild);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.nw(finalState);
}
function nextChild($this, $receiver) {
  var cur = $receiver;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur.m12_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur.l12_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur.k12_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur.m12_1)
      continue $l$loop_0;
    if (cur instanceof ChildHandleNode())
      return cur;
    if (cur instanceof NodeList())
      return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing()) {
    tmp = state.t14() ? 'Cancelling' : state.f15() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete()) : false) {
      tmp = state.dw() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally()) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
var FinishingClass;
function Finishing() {
  if (FinishingClass === VOID) {
    class $ extends SynchronizedObject() {
      constructor(list, isCompleting, rootCause) {
        super();
        this.p14_1 = list;
        this.q14_1 = atomic$boolean$1(isCompleting);
        this.r14_1 = atomic$ref$1(rootCause);
        this.s14_1 = atomic$ref$1(null);
      }
      j12() {
        return this.p14_1;
      }
      j15(value) {
        this.q14_1.kotlinx$atomicfu$value = value;
      }
      f15() {
        return this.q14_1.kotlinx$atomicfu$value;
      }
      p15(value) {
        this.r14_1.kotlinx$atomicfu$value = value;
      }
      i15() {
        return this.r14_1.kotlinx$atomicfu$value;
      }
      g15() {
        return _get_exceptionsHolder__nhszp(this) === get_SEALED();
      }
      t14() {
        return !(this.i15() == null);
      }
      dw() {
        return this.i15() == null;
      }
      u14(proposedException) {
        var eh = _get_exceptionsHolder__nhszp(this);
        var tmp;
        if (eh == null) {
          tmp = allocateList(this);
        } else {
          if (eh instanceof Error) {
            // Inline function 'kotlin.also' call
            var this_0 = allocateList(this);
            this_0.j2(eh);
            tmp = this_0;
          } else {
            if (eh instanceof ArrayList()) {
              tmp = eh instanceof ArrayList() ? eh : THROW_CCE();
            } else {
              // Inline function 'kotlin.error' call
              var message = 'State is ' + toString(eh);
              throw IllegalStateException().o(toString(message));
            }
          }
        }
        var list = tmp;
        var rootCause = this.i15();
        if (rootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          list.t4(0, rootCause);
        }
        if (!(proposedException == null) && !equals(proposedException, rootCause)) {
          list.j2(proposedException);
        }
        _set_exceptionsHolder__tqm22h(this, get_SEALED());
        return list;
      }
      h15(exception) {
        var rootCause = this.i15();
        if (rootCause == null) {
          this.p15(exception);
          return Unit_instance;
        }
        if (exception === rootCause)
          return Unit_instance;
        var eh = _get_exceptionsHolder__nhszp(this);
        if (eh == null) {
          _set_exceptionsHolder__tqm22h(this, exception);
        } else {
          if (eh instanceof Error) {
            if (exception === eh)
              return Unit_instance;
            // Inline function 'kotlin.apply' call
            var this_0 = allocateList(this);
            this_0.j2(eh);
            this_0.j2(exception);
            _set_exceptionsHolder__tqm22h(this, this_0);
          } else {
            if (eh instanceof ArrayList()) {
              (eh instanceof ArrayList() ? eh : THROW_CCE()).j2(exception);
            } else {
              // Inline function 'kotlin.error' call
              var message = 'State is ' + toString(eh);
              throw IllegalStateException().o(toString(message));
            }
          }
        }
      }
      toString() {
        return 'Finishing[cancelling=' + this.t14() + ', completing=' + this.f15() + ', rootCause=' + toString_0(this.i15()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.p14_1.toString() + ']';
      }
    }
    initMetadataForClass($, 'Finishing', VOID, VOID, [Incomplete()]);
    FinishingClass = $;
  }
  return FinishingClass;
}
var ChildCompletionClass;
function ChildCompletion() {
  if (ChildCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(parent, state, child, proposedUpdate) {
        super();
        this.u15_1 = parent;
        this.v15_1 = state;
        this.w15_1 = child;
        this.x15_1 = proposedUpdate;
      }
      d12() {
        return false;
      }
      sz(cause) {
        continueCompleting(this.u15_1, this.v15_1, this.w15_1, this.x15_1);
      }
    }
    initMetadataForClass($, 'ChildCompletion');
    ChildCompletionClass = $;
  }
  return ChildCompletionClass;
}
var AwaitContinuationClass;
function AwaitContinuation() {
  if (AwaitContinuationClass === VOID) {
    class $ extends CancellableContinuationImpl() {
      constructor(delegate, job) {
        super(delegate, 1);
        this.e16_1 = job;
      }
      h11(parent) {
        var state = this.e16_1.xw();
        if (state instanceof Finishing()) {
          var tmp0_safe_receiver = state.i15();
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            return tmp0_safe_receiver;
          }
        }
        if (state instanceof CompletedExceptionally())
          return state.iw_1;
        return parent.cx();
      }
      u11() {
        return 'AwaitContinuation';
      }
    }
    initMetadataForClass($, 'AwaitContinuation');
    AwaitContinuationClass = $;
  }
  return AwaitContinuationClass;
}
function *awaitSuspend($this, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cont = new (AwaitContinuation())(intercepted(uCont), $this);
    cont.a11();
    disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new (ResumeAwaitOnCompletion())(cont)));
    return cont.ky();
  };
}
var JobSupportClass;
function JobSupport() {
  if (JobSupportClass === VOID) {
    class $ {
      constructor(active) {
        this.wv_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
        this.xv_1 = atomic$ref$1(null);
      }
      m3() {
        return Key_instance;
      }
      uw(value) {
        this.xv_1.kotlinx$atomicfu$value = value;
      }
      vw() {
        return this.xv_1.kotlinx$atomicfu$value;
      }
      ww() {
        var tmp0_safe_receiver = this.vw();
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ww();
      }
      yv(parent) {
        // Inline function 'kotlinx.coroutines.assert' call
        if (parent == null) {
          this.uw(NonDisposableHandle_instance);
          return Unit_instance;
        }
        parent.ax();
        var handle = parent.vx(this);
        this.uw(handle);
        if (this.yw()) {
          handle.tz();
          this.uw(NonDisposableHandle_instance);
        }
      }
      xw() {
        return this.wv_1.kotlinx$atomicfu$value;
      }
      dw() {
        var state = this.xw();
        var tmp;
        if (!(state == null) ? isInterface(state, Incomplete()) : false) {
          tmp = state.dw();
        } else {
          tmp = false;
        }
        return tmp;
      }
      yw() {
        var tmp = this.xw();
        return !(!(tmp == null) ? isInterface(tmp, Incomplete()) : false);
      }
      zw() {
        var state = this.xw();
        var tmp;
        if (state instanceof CompletedExceptionally()) {
          tmp = true;
        } else {
          var tmp_0;
          if (state instanceof Finishing()) {
            tmp_0 = state.t14();
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      ax() {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var state = this.xw();
          var tmp0_subject = startInternal(this, state);
          if (tmp0_subject === 0)
            return false;
          else if (tmp0_subject === 1)
            return true;
        }
      }
      bx() {
      }
      cx() {
        var state = this.xw();
        var tmp;
        if (state instanceof Finishing()) {
          var tmp0_safe_receiver = state.i15();
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.dx(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.error' call
            var message = 'Job is still new or active: ' + this.toString();
            throw IllegalStateException().o(toString(message));
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          tmp = tmp_0;
        } else {
          if (!(state == null) ? isInterface(state, Incomplete()) : false) {
            // Inline function 'kotlin.error' call
            var message_0 = 'Job is still new or active: ' + this.toString();
            throw IllegalStateException().o(toString(message_0));
          } else {
            if (state instanceof CompletedExceptionally()) {
              tmp = this.ex(state.iw_1);
            } else {
              tmp = JobCancellationException().b15(get_classSimpleName(this) + ' has completed normally', null, this);
            }
          }
        }
        return tmp;
      }
      dx(_this__u8e3s4, message) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException() ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().b15(message == null ? this.gw() : message, _this__u8e3s4, this);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      ex(_this__u8e3s4, message, $super) {
        message = message === VOID ? null : message;
        return $super === VOID ? this.dx(_this__u8e3s4, message) : $super.dx.call(this, _this__u8e3s4, message);
      }
      fx(handler) {
        return this.ix(true, new (InvokeOnCompletion())(handler));
      }
      gx(onCancelling, invokeImmediately, handler) {
        var tmp;
        if (onCancelling) {
          tmp = new (InvokeOnCancelling())(handler);
        } else {
          tmp = new (InvokeOnCompletion())(handler);
        }
        return this.ix(invokeImmediately, tmp);
      }
      ix(invokeImmediately, node) {
        node.h12_1 = this;
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
          // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
          while (true) {
            var state = this.xw();
            if (state instanceof Empty()) {
              if (state.e15_1) {
                if (this.wv_1.atomicfu$compareAndSet(state, node)) {
                  tmp$ret$0 = true;
                  break $l$block_1;
                }
              } else {
                promoteEmptyToNodeList(this, state);
              }
            } else {
              if (!(state == null) ? isInterface(state, Incomplete()) : false) {
                var list = state.j12();
                if (list == null) {
                  promoteSingleToNodeList(this, state instanceof JobNode() ? state : THROW_CCE());
                } else {
                  var tmp;
                  if (node.d12()) {
                    var tmp0_safe_receiver = state instanceof Finishing() ? state : null;
                    var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i15();
                    var tmp_0;
                    if (rootCause == null) {
                      tmp_0 = list.n12(node, 5);
                    } else {
                      if (invokeImmediately) {
                        node.sz(rootCause);
                      }
                      return NonDisposableHandle_instance;
                    }
                    tmp = tmp_0;
                  } else {
                    tmp = list.n12(node, 1);
                  }
                  if (tmp) {
                    tmp$ret$0 = true;
                    break $l$block_1;
                  }
                }
              } else {
                tmp$ret$0 = false;
                break $l$block_1;
              }
            }
          }
        }
        var added = tmp$ret$0;
        if (added)
          return node;
        else if (invokeImmediately) {
          var tmp_1 = this.xw();
          var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally() ? tmp_1 : null;
          node.sz(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.iw_1);
        }
        return NonDisposableHandle_instance;
      }
      *jx($completion) {
        if (!joinInternal(this)) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var tmp$ret$0 = $completion.pc();
          ensureActive(tmp$ret$0);
          return Unit_instance;
        }
        return yield* /*#__NOINLINE__*/joinSuspend(this, $completion);
      }
      kx(node) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var state = this.xw();
          if (state instanceof JobNode()) {
            if (!(state === node))
              return Unit_instance;
            if (this.wv_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
              return Unit_instance;
          } else {
            if (!(state == null) ? isInterface(state, Incomplete()) : false) {
              if (!(state.j12() == null)) {
                node.o12();
              }
              return Unit_instance;
            } else {
              return Unit_instance;
            }
          }
        }
      }
      lx() {
        return false;
      }
      mx(cause) {
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().b15(null == null ? this.gw() : null, null, this);
        } else {
          tmp = cause;
        }
        this.ox(tmp);
      }
      gw() {
        return 'Job was cancelled';
      }
      ox(cause) {
        this.sx(cause);
      }
      px(parentJob) {
        this.sx(parentJob);
      }
      qx(cause) {
        if (cause instanceof CancellationException())
          return true;
        return this.sx(cause) && this.yx();
      }
      rx(cause) {
        return this.sx(cause);
      }
      sx(cause) {
        var finalState = get_COMPLETING_ALREADY();
        if (this.lx()) {
          finalState = cancelMakeCompleting(this, cause);
          if (finalState === get_COMPLETING_WAITING_CHILDREN())
            return true;
        }
        if (finalState === get_COMPLETING_ALREADY()) {
          finalState = makeCancelling(this, cause);
        }
        var tmp;
        if (finalState === get_COMPLETING_ALREADY()) {
          tmp = true;
        } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
          tmp = true;
        } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
          tmp = false;
        } else {
          this.nw(finalState);
          tmp = true;
        }
        return tmp;
      }
      tx() {
        var state = this.xw();
        var tmp;
        if (state instanceof Finishing()) {
          tmp = state.i15();
        } else {
          if (state instanceof CompletedExceptionally()) {
            tmp = state.iw_1;
          } else {
            if (!(state == null) ? isInterface(state, Incomplete()) : false) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot be cancelling child in this state: ' + toString(state);
              throw IllegalStateException().o(toString(message));
            } else {
              tmp = null;
            }
          }
        }
        var rootCause = tmp;
        var tmp1_elvis_lhs = rootCause instanceof CancellationException() ? rootCause : null;
        return tmp1_elvis_lhs == null ? JobCancellationException().b15('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
      }
      ux(proposedUpdate) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var tmp0 = this.xw();
          $l$block: {
            var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
            if (finalState === get_COMPLETING_ALREADY())
              return false;
            else if (finalState === get_COMPLETING_WAITING_CHILDREN())
              return true;
            else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else {
              this.nw(finalState);
              return true;
            }
          }
        }
      }
      lw(proposedUpdate) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while (true) {
          var tmp0 = this.xw();
          $l$block: {
            var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
            if (finalState === get_COMPLETING_ALREADY())
              throw IllegalStateException().q('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
            else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        }
      }
      vx(child) {
        // Inline function 'kotlin.also' call
        var this_0 = new (ChildHandleNode())(child);
        this_0.h12_1 = this;
        var node = this_0;
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
          // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
          while (true) {
            var state = this.xw();
            if (state instanceof Empty()) {
              if (state.e15_1) {
                if (this.wv_1.atomicfu$compareAndSet(state, node)) {
                  tmp$ret$2 = true;
                  break $l$block_1;
                }
              } else {
                promoteEmptyToNodeList(this, state);
              }
            } else {
              if (!(state == null) ? isInterface(state, Incomplete()) : false) {
                var list = state.j12();
                if (list == null) {
                  promoteSingleToNodeList(this, state instanceof JobNode() ? state : THROW_CCE());
                } else {
                  var addedBeforeCancellation = list.n12(node, 7);
                  var tmp;
                  if (addedBeforeCancellation) {
                    tmp = true;
                  } else {
                    var addedBeforeCompletion = list.n12(node, 3);
                    var latestState = this.xw();
                    var tmp_0;
                    if (latestState instanceof Finishing()) {
                      tmp_0 = latestState.i15();
                    } else {
                      // Inline function 'kotlinx.coroutines.assert' call
                      var tmp0_safe_receiver = latestState instanceof CompletedExceptionally() ? latestState : null;
                      tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iw_1;
                    }
                    var rootCause = tmp_0;
                    node.sz(rootCause);
                    var tmp_1;
                    if (addedBeforeCompletion) {
                      // Inline function 'kotlinx.coroutines.assert' call
                      tmp_1 = true;
                    } else {
                      return NonDisposableHandle_instance;
                    }
                    tmp = tmp_1;
                  }
                  if (tmp) {
                    tmp$ret$2 = true;
                    break $l$block_1;
                  }
                }
              } else {
                tmp$ret$2 = false;
                break $l$block_1;
              }
            }
          }
        }
        var added = tmp$ret$2;
        if (added)
          return node;
        var tmp_2 = this.xw();
        var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally() ? tmp_2 : null;
        node.sz(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.iw_1);
        return NonDisposableHandle_instance;
      }
      ow(exception) {
        throw exception;
      }
      wx(cause) {
      }
      xx() {
        return false;
      }
      yx() {
        return true;
      }
      zx(exception) {
        return false;
      }
      hw(state) {
      }
      nw(state) {
      }
      toString() {
        return this.ay() + '@' + get_hexAddress(this);
      }
      ay() {
        return this.pw() + '{' + stateString(this, this.xw()) + '}';
      }
      pw() {
        return get_classSimpleName(this);
      }
      by() {
        var state = this.xw();
        // Inline function 'kotlin.check' call
        if (!!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
          var message = 'This job has not completed yet';
          throw IllegalStateException().o(toString(message));
        }
        return _get_exceptionOrNull__b3j7js(this, state);
      }
      cy() {
        var state = this.xw();
        // Inline function 'kotlin.check' call
        if (!!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
          var message = 'This job has not completed yet';
          throw IllegalStateException().o(toString(message));
        }
        if (state instanceof CompletedExceptionally())
          throw state.iw_1;
        return unboxState(state);
      }
      *dy($completion) {
        $l$loop: while (true) {
          var state = this.xw();
          if (!(!(state == null) ? isInterface(state, Incomplete()) : false)) {
            if (state instanceof CompletedExceptionally()) {
              // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
              throw state.iw_1;
            }
            return unboxState(state);
          }
          if (startInternal(this, state) >= 0)
            break $l$loop;
        }
        return yield* /*#__NOINLINE__*/awaitSuspend(this, $completion);
      }
    }
    protoOf($).hx = invokeOnCompletion$default;
    protoOf($).nx = cancel$default;
    protoOf($).qm = plus;
    protoOf($).bd = get;
    protoOf($).pm = fold;
    protoOf($).om = minusKey;
    initMetadataForClass($, 'JobSupport', VOID, VOID, [Job(), ParentJob()], [0]);
    JobSupportClass = $;
  }
  return JobSupportClass;
}
function handlesExceptionF($this) {
  var tmp = $this.vw();
  var tmp0_safe_receiver = tmp instanceof ChildHandleNode() ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i12();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.yx())
      return true;
    var tmp_1 = parentJob.vw();
    var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode() ? tmp_1 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i12();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
var JobImplClass;
function JobImpl() {
  if (JobImplClass === VOID) {
    class $ extends JobSupport() {
      constructor(parent) {
        super(true);
        this.yv(parent);
        this.h16_1 = handlesExceptionF(this);
      }
      lx() {
        return true;
      }
      yx() {
        return this.h16_1;
      }
      u12() {
        return this.ux(Unit_instance);
      }
      t12(exception) {
        return this.ux(new (CompletedExceptionally())(exception));
      }
    }
    initMetadataForClass($, 'JobImpl', VOID, VOID, [CompletableJob()], [0]);
    JobImplClass = $;
  }
  return JobImplClass;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      constructor(isActive) {
        this.e15_1 = isActive;
      }
      dw() {
        return this.e15_1;
      }
      j12() {
        return null;
      }
      toString() {
        return 'Empty{' + (this.e15_1 ? 'Active' : 'New') + '}';
      }
    }
    initMetadataForClass($, 'Empty', VOID, VOID, [Incomplete()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var IncompleteClass;
function Incomplete() {
  if (IncompleteClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Incomplete');
    IncompleteClass = $;
  }
  return IncompleteClass;
}
var NodeListClass;
function NodeList() {
  if (NodeListClass === VOID) {
    class $ extends LockFreeLinkedListHead() {
      dw() {
        return true;
      }
      j12() {
        return this;
      }
      l16(state) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1('List{');
        this_0.m1(state);
        this_0.m1('}[');
        var first = true;
        // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
        var cur = this.k12_1;
        while (!equals(cur, this)) {
          var node = cur;
          if (node instanceof JobNode()) {
            if (first) {
              first = false;
            } else
              this_0.m1(', ');
            this_0.s1(node);
          }
          cur = cur.k12_1;
        }
        this_0.m1(']');
        return this_0.toString();
      }
      toString() {
        return get_DEBUG() ? this.l16('Active') : super.toString();
      }
    }
    initMetadataForClass($, 'NodeList', NodeList, VOID, [Incomplete()]);
    NodeListClass = $;
  }
  return NodeListClass;
}
var IncompleteStateBoxClass;
function IncompleteStateBox() {
  if (IncompleteStateBoxClass === VOID) {
    class $ {
      constructor(state) {
        this.o14_1 = state;
      }
    }
    initMetadataForClass($, 'IncompleteStateBox');
    IncompleteStateBoxClass = $;
  }
  return IncompleteStateBoxClass;
}
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete()) : false) {
    tmp = new (IncompleteStateBox())(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
var InactiveNodeListClass;
function InactiveNodeList() {
  if (InactiveNodeListClass === VOID) {
    class $ {
      constructor(list) {
        this.d15_1 = list;
      }
      j12() {
        return this.d15_1;
      }
      dw() {
        return false;
      }
      toString() {
        return get_DEBUG() ? this.d15_1.l16('New') : anyToString(this);
      }
    }
    initMetadataForClass($, 'InactiveNodeList', VOID, VOID, [Incomplete()]);
    InactiveNodeListClass = $;
  }
  return InactiveNodeListClass;
}
var InvokeOnCompletionClass;
function InvokeOnCompletion() {
  if (InvokeOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(handler) {
        super();
        this.q16_1 = handler;
      }
      d12() {
        return false;
      }
      sz(cause) {
        return this.q16_1(cause);
      }
    }
    initMetadataForClass($, 'InvokeOnCompletion');
    InvokeOnCompletionClass = $;
  }
  return InvokeOnCompletionClass;
}
var InvokeOnCancellingClass;
function InvokeOnCancelling() {
  if (InvokeOnCancellingClass === VOID) {
    class $ extends JobNode() {
      constructor(handler) {
        super();
        this.v16_1 = handler;
        this.w16_1 = atomic$boolean$1(false);
      }
      d12() {
        return true;
      }
      sz(cause) {
        if (this.w16_1.atomicfu$compareAndSet(false, true))
          this.v16_1(cause);
      }
    }
    initMetadataForClass($, 'InvokeOnCancelling');
    InvokeOnCancellingClass = $;
  }
  return InvokeOnCancellingClass;
}
var ResumeOnCompletionClass;
function ResumeOnCompletion() {
  if (ResumeOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(continuation) {
        super();
        this.b17_1 = continuation;
      }
      d12() {
        return false;
      }
      sz(cause) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = this.b17_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.rc(tmp$ret$1);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ResumeOnCompletion');
    ResumeOnCompletionClass = $;
  }
  return ResumeOnCompletionClass;
}
var ChildHandleNodeClass;
function ChildHandleNode() {
  if (ChildHandleNodeClass === VOID) {
    class $ extends JobNode() {
      constructor(childJob) {
        super();
        this.o15_1 = childJob;
      }
      ww() {
        return this.i12();
      }
      d12() {
        return true;
      }
      sz(cause) {
        return this.o15_1.px(this.i12());
      }
      qx(cause) {
        return this.i12().qx(cause);
      }
    }
    initMetadataForClass($, 'ChildHandleNode', VOID, VOID, [DisposableHandle()]);
    ChildHandleNodeClass = $;
  }
  return ChildHandleNodeClass;
}
var ResumeAwaitOnCompletionClass;
function ResumeAwaitOnCompletion() {
  if (ResumeAwaitOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(continuation) {
        super();
        this.g17_1 = continuation;
      }
      d12() {
        return false;
      }
      sz(cause) {
        var state = this.i12().xw();
        // Inline function 'kotlinx.coroutines.assert' call
        if (state instanceof CompletedExceptionally()) {
          var tmp0 = this.g17_1;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = state.iw_1;
          var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0.rc(tmp$ret$2);
        } else {
          var tmp0_0 = this.g17_1;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = unboxState(state);
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          tmp0_0.rc(tmp$ret$4);
        }
      }
    }
    initMetadataForClass($, 'ResumeAwaitOnCompletion');
    ResumeAwaitOnCompletionClass = $;
  }
  return ResumeAwaitOnCompletionClass;
}
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new (Symbol())('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new (Symbol())('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new (Symbol())('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new (Symbol())('TOO_LATE_TO_CANCEL');
    SEALED = new (Symbol())('SEALED');
    EMPTY_NEW = new (Empty())(false);
    EMPTY_ACTIVE = new (Empty())(true);
  }
}
function JobNode$invoke$ref(p0) {
  return constructCallableReference((p0_0) => {
    p0.sz(p0_0);
    return Unit_instance;
  }, 1, 0, 0, 'invoke', [p0]);
}
//region block: exports
export {
  JobNode$invoke$ref as JobNode$invoke$refosvo6j3dhivj,
  get_COMPLETING_WAITING_CHILDREN as get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1,
  JobImpl as JobImpl2fbttqo93wxua,
  JobNode as JobNode2tu3g3s3xsko1,
  JobSupport as JobSupport3fdjh0rbee4be,
  unboxState as unboxStateze7t12boxn2m,
};
//endregion

//# sourceMappingURL=JobSupport.mjs.map
